import Typography, { TypographyProps } from '@mui/material/Typography';

export default Typography;
export type { TypographyProps };
export { Typography };
